// extracted by mini-css-extract-plugin
export default {"text":"text_dFXUo","list":"list_fISgs"};